import { useState } from "react";
import ErrorBoundary from "@/components/ErrorBoundary";
import WorkspaceAudioSetup from "@/components/mist/WorkspaceAudioSetup";
import WorkspaceVisualStudio from "@/components/mist/WorkspaceVisualStudio";

/* Singer Studio — a 2-workspace decoupled model:
   Workspace 1 (Audio Engine)  → pick + trim a track, then lock it in.
   Workspace 2 (Visual Studio) → direct the look and render the singing reel.
   Both are wrapped in a crash guardrail so any exception becomes a toast,
   never a white-screened site. */
export default function SingingCharacterStudio() {
  const [track, setTrack] = useState(null); // { assetId, title, length }
  return (
    <div className="h-full w-full overflow-y-auto bg-[#0A0A0A] text-white" data-testid="singing-character-studio">
      <ErrorBoundary>
        {track
          ? <WorkspaceVisualStudio track={track} onChangeSong={() => setTrack(null)} />
          : <WorkspaceAudioSetup onLocked={setTrack} />}
      </ErrorBoundary>
    </div>
  );
}
